var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.headers),function(key,index){return [_c('span',{key:index,staticClass:"table__body__row__text position--relative",class:("table__" + _vm.model + "__col__" + index)},[_vm._v(" "+_vm._s(_vm.row[key] || '---')+" ")])]}),_c('div',{staticClass:"table__request__col__5 display--flex row__request__actions"},[_c('button-with-icon',{class:[
                'table__body__row__text__button'
            ],attrs:{"icon":Object.assign({}, {component: function () { return import( /* webpackChunkName: 'IconListen' */ '@/components/bundles/layout/images/icons/IconListen' ); }},
                ( _vm.call.confirmed && {
                    class: 'row__request__actions__listen--active'
                }),
                ( _vm.listen.loading && {
                    class: 'row__request__actions__default--loading'
                })),"aria-label":_vm.$t('accessibility.toListen'),"action":{
                execute: true,
                function: _vm.toggleListenCall,
                param: { extension: _vm.row.extension }
            }}}),(_vm.row.id)?_c('button-with-icon',{class:[
                'table__body__row__text__button'
            ],attrs:{"icon":Object.assign({}, {component: function () { return import( /* webpackChunkName: 'IconTransferCall' */ '@/components/bundles/layout/images/icons/IconTransferCall' ); }},
                ( _vm.intercept.loading && {
                    class: 'row__request__actions__default--loading'
                })),"aria-label":_vm.$t('accessibility.transferCall'),"action":{
                execute: true,
                function: _vm.interceptCall,
                param: { id: _vm.row.id, extension: _vm.row.extension }
            }}}):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }